const readRequiredUrl = (name) => {
  const value = process.env[name]?.trim()
  if (!value) {
    throw new Error(`${name} is required. Configure it in a local environment file.`)
  }
  return value.replace(/\/+$/, '')
}

export const URL = readRequiredUrl('REACT_APP_KAMS_API_URL')
export const URLKpostLogin = readRequiredUrl('REACT_APP_KPOST_LOGIN_URL')
export const AdminURL = readRequiredUrl('REACT_APP_ADMIN_API_URL')
